<div id="wrapper">
  <div class="vertical-align-wrap">
    <div class="vertical-align-middle auth-main">
      <div class="auth-box">
        <div class="top text-white font-weight-bold">
          <img src="../assets/images/logo/ridereg_logo-white.png" alt="RideReg" class="img-responsive logo">
        </div>
        <div class="card">
          <div class="header">
            <p class="lead">Recover my password</p>
          </div>
          <div class="body">
            <p>Please enter your email address below to receive instructions for resetting password.</p>
            <form class="form-auth-small"  #forgotPForm="ngForm" (ngSubmit)="forgotPassword()">
              <div class="form-group">
                <input type="email" class="form-control"  placeholder="Email"
                       #email="ngModel" id="email"
                       [(ngModel)]="credentials.email" [pattern]="EMAIL_VALIDATION" [ngModelOptions]="{standalone: true}" required>
                <div class="text-danger"  *ngIf="email.errors && (email.dirty || email.touched)" style="margin-top: -5px;">
                  <span class="validation-message" [hidden]="!email.hasError('pattern')">
                 Invalid Email Address</span>
                  <span class="validation-message" [hidden]="!email.hasError('required')">
                 Email Address is required</span>
                </div>
              </div>
              <button type="submit" class="btn btn-primary btn-lg btn-block" *ngIf="!loaders.loading" [disabled]="email.errors" >RESET PASSWORD</button>
              <span *ngIf="loaders.loading" class="btn btn-primary btn-lg btn-block">Loading&nbsp;<i class="fa fa-spin fa-spinner"></i></span >

              <div class="bottom">
                <span class="helper-text">Remember password? <a  [routerLink]="['/login']">Login</a></span>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
